import { IconProp, SizeProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonProps } from 'react-bootstrap';

interface CustomButtonProps extends ButtonProps {
    className: string;
    icon?: IconProp;
    title?: string;
    iconClass?: string;
    iconSize?: SizeProp;
    tooltipTitle?: string;
    buttonSize?: 'sm' | 'lg';
}

export const CustomButton = ({
    className,
    icon,
    title,
    iconClass,
    iconSize,
    buttonSize,
    tooltipTitle,
    ...buttonProps
}: CustomButtonProps) => {
    return (
        <Button size={buttonSize || 'sm'} className={className} title={tooltipTitle} {...buttonProps}>
            {icon && <FontAwesomeIcon icon={icon} size={iconSize || 'sm'} className={iconClass} />}
            {title && <p className='mb-0 d-inline ms-1'>{title}</p>}
        </Button>
    );
};
